import CartOptionItem from '@/components/cart/cart-option-item';
import { Separator } from '@/components/ui/separator';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import { Cart } from '@/schema/cart';
import Image from 'next/image';
import React from 'react';
import '@/app/input.css';

function CartItem({
  cart,
  lang,
  currency,
  dataDate,
}: {
  cart: Cart;
  lang: Languages;
  currency: string;
  dataDate: number;
}) {
  const dict = useDictionary();

  return (
    <div className="bg-[#FFF5F5] shadow-md h-auto w-full rounded-xl mb-5 p-4 inline-flex flex-col gap-[15px] lg:gap-5">
      <div className="inline-flex flex-row gap-2.5 lg:gap-3 items-start">
        <div className="w-8 h-8 lg:w-[60px] lg:h-[60px] relative">
          <Image
            src={cart.shop.thumbnail.url}
            alt={cart.shop.title[lang]}
            fill
          />
        </div>
        <div className="flex-1 inline-flex flex-col gap-[3px]">
          <span className="giftifan5 font-bold text-lg lg:text-2xl leading-none align-top">
            {cart.shop.title[lang]}
          </span>
        </div>
      </div>
      <Separator className="text-[#EEEEEE]" />
      <div className="inline-flex flex-col gap-4">
        {cart.cart.result.map((item, index: number) => (
          <CartOptionItem
            shopId={cart.shopId}
            option={item}
            currency={currency}
            key={`${cart.shopId}-${index}-${dataDate}`}
          />
        ))}
      </div>
      <div className="inline-flex flex-row justify-between">
        <span className="font-bold giftifan5 text-lg">
          {dict!.delivery.totalAmount}
        </span>
        <span className="font-bold giftifan5 text-lg">
          {cart.cart.totalPrice.toLocaleString('en-US')}
          {currency}
        </span>
      </div>
    </div>
  );
}

export default CartItem;
